module.exports = __webpack_public_path__ + "img/hr-radar-shadow.1ca57594.png";